import React from 'react';
import { View, Text, ScrollView, StyleSheet, Linking } from 'react-native';

import Colors from '../../constants/Colors';
import { ImageDisplay, Button } from '../../components/'
import {NEWS_GET_IMAGE} from "./api/newsEndpoints";
import NavBar from "../../components/NavBar";

class NewsReadingScreen extends React.Component {

    render() {

        const newsData = this.props.history.location.state.newsData;
        const {title, longDescription, externalLink} = newsData;

        return (
            <NavBar title={"Notícia"}>

                <ScrollView contentContainerStyle={{alignItems: 'center', paddingBottom: 20}}>
                    <Text style={styles.titleStyle}>
                        {title}
                    </Text>

                    <ImageDisplay
                        imageUrl={NEWS_GET_IMAGE(newsData.uniqueId)}
                        authToken={this.props.authToken}
                        propsContainerStyle={{ height: 400, width: 400}}
                        propsImageStyle={{ height: 400, width: 400, borderRadius: 8 }}
                    />

                    <Text style={styles.descriptionStyle} selectable={true}>
                        {longDescription}
                    </Text>

                    {
                        externalLink &&
                    	<Button
		                    text={'Link'}
		                    textPropsStyle={{ fontWeight: 'bold' }}

                            //TODO(Celso): Adicionar log para clique de usuário neste link externo!
		                    onPress={() => Linking.openURL(externalLink)}
		                    containerPropsStyle={{
		                        backgroundColor: Colors.buttonColor,
		                        borderColor: Colors.buttonColor,
		                        height: 50,
		                        margin: 34,
		                    }}
		                />
                    }

                </ScrollView>
            </NavBar>
        )
    }
}

const styles = StyleSheet.create({
    containerStyle: {
        flex: 1,
        backgroundColor: Colors.backgroundColor
    },
    imageStyle: {
        width: 300,
        height: 200,
        maxWidth: 300,
        maxHeight: 200,
        alignSelf: 'center',
    },
    titleStyle: {
        textAlign: 'center',
        fontWeight: 'bold',
        color: Colors.inputFontColor,
        fontSize: 24,
        marginBottom: 20,
        marginTop: 10,
    },
    descriptionStyle: {
        maxWidth: '90%',
        fontSize: 18,
        color: Colors.inputFontColor,
        marginTop: 30,
    }
});

export default NewsReadingScreen;
